/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */



const braverman =
            [

                {
                    question: 'I have trouble paying consistent attention and concentrating',
                    neuroType: 'D',
                    testType: 'Def'
                }, {
                question: 'I need caffeine to wake up',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I cannot think quickly enough',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I do not have a good attention span',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I have trouble getting through a task even when it is interesting to me',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I am slow in learning new ideas',
                neuroType: 'D',
                testType: 'Def'
            }, {question: 'I crave sugar', neuroType: 'D', testType: 'Def'}, {
                question: 'I have decreased libido',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I sleep too much',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I have a history of alcohol or addiction',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I have recently felt worn out for no apparent reason',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I sometimes experience total exhaustion without even exerting myself',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I have always battled weight problems',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I have little motivation for sexual experiences',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I have little trouble getting out of bed in the mornign',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I have had a craving for cocaine, amphetamines, or Ecstasy',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I feel fine just following others',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'People seem to take advantage of me',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I am feeling very down or depressed',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'People have told me I am too mellow',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I have little urgency',
                neuroType: 'D',
                testType: 'Def'
            }, {
                question: 'I let people criticize me ',
                neuroType: 'D',
                testType: 'Def'
            }, {question: 'I always look to others to lead me', neuroType: 'D', testType: 'Def'}, {
                question: 'I have lost my reasoning skills', neuroType: 'D', testType:
                    'Def'
            }
                ,
                {
                    question: 'I can’t make good decisions', neuroType:
                    'D', testType:
                    'Def'
                }
                ,

                {
                    question: 'I lack imagination', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have difficulty remembering names when I first meet people', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have noticed that my memory ability is decreasing', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'My significant other tells me I don’t have romantic thoughts', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I can’t remember my friend’s birthday', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have lost some of my creativity', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have insomnia', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have lost muscle tone', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I don’t exercise anymore', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I crave fatty food', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have experimented with hallucinogens or other illicit drugs', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I feel like my body is falling apart', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: ' I can’t breathe easily', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I don’t feel joy very often', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I feel despair', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I protect myself from being hurt by others by never telling much about myself',
                    neuroType:
                        'A',
                    testType:
                        'Def'
                }
                ,
                {
                    question: 'I find it more comfortable to do things alone rather than in a large group', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'Other people get angrier about bothersome things than I do', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I give in easily and tend to be submissive', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I rarely feel passionate about anything', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I like routine', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I don’t care about anyone’s stories but my own', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I don’t pay attention to people’s feelings', neuroType:
                    'A', testType:
                    'Def'
                }
                ,
                {
                    question: 'I don’t feel buoyant', neuroType:
                    'A', testType:
                    'Def'
                }
                ,

                {
                    question: 'I find it difficult to concentrate because I’m nervous and jumpy', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I can’t remember phone numbers', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have trouble finding the right word', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have trouble remembering things when I am put on the spot', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I know I am intelligent, but it is hard to show others', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'My ability to focus comes and goes', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'When I read, I find I have to go back over the same paragraph a few times to absorb the information',
                    neuroType:
                        'G',
                    testType:
                        'Def'
                }
                ,
                {
                    question: 'I am a quick thinker but can’t always say what I mean', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I feel shaky', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I sometimes tremble', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have frequent backaches and/or headaches', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I tend to have shortness of breath', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I tend to have heart palpitations', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I tend to have cold hands', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I sometimes sweat too much', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I am sometimes dizzy', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I often have muscle tension', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I tend to get butterflies in my stomach', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I crave bitter foods', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I am often nervous', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I like yoga because it helps me to relax', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I often feel fatigued even when I have had a good night’s sleep', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I overeat', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have mood swings', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I enjoy doing many things at one time, but I find it difficult to decide what to do first',
                    neuroType:
                        'G',
                    testType:
                        'Def'
                }
                ,
                {
                    question: 'I tend to do things just because I think they’d be fun', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'When things are dull, I always try to introduce some excitement', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I tend to be fickle, changing my mood and thoughts frequently', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I tend to get overly excited about things', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'My impulses tend to get me into a lot of trouble', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I tend to be theatrical and draw attention to myself', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I speak my mind no matter what the reaction of others may be', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I sometimes have fits of rage and then feel terribly guilty', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I often tell lies to get out of trouble', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have always had less interest than the average person in sex', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I don’t play by the rules anymore', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have lost my friends', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I can’t sustain romantic relationships', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I consider the law arbitrary and without reason', neuroType:
                    'G', testType:
                    'Def'
                }
                ,
                {
                    question: 'I now consider rules that I used to follow ridiculous', neuroType:
                    'G', testType:
                    'Def'
                }
                ,

                {
                    question: 'I am not very perceptive', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I can’t remember things that I have seen in the past', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have a slow reaction time', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have a poor sense of direction', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have night sweats', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have insomnia', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I tend to sleep in many different positions in order to feel comfortable', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I always awake early in the morning', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I can’t relax', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I wake up at least two times per night', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'It is difficult for me to fall back asleep when I am awakened', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I crave salt', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have less energy to exercise', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I am sad', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have chronic anxiety', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I am easily irritated', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have thoughts of self-destruction', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I have had suicidal thoughts in my life', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I tend to dwell on ideas too much', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I am sometimes so structured that I become inflexible', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'My imagination takes over', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'Fear grips me', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I can’t stop thinking about the meaning of life', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'I no longer want to take risks', neuroType:
                    'S', testType:
                    'Def'
                }
                ,
                {
                    question: 'The lack of meaning in my life is painful to me', neuroType:
                    'S', testType:
                    'Def'
                }];


export default braverman;



// WEBPACK FOOTER //
// ./src/BravermanData.js